import React, { useCallback } from 'react';
import { Switch } from '@cbhq/cds-web/controls/Switch';
import { HStack } from '@cbhq/cds-web/layout';
import { TextHeadline } from '@cbhq/cds-web/typography';
import { useChainSwitch } from './ChainSwitchContext';

type TestnetToggleButtonProps = {
  onPress?: () => void;
};

export function TestnetToggleButton({ onPress }: TestnetToggleButtonProps) {
  const { isTestnetEnabled, toggleTestnetMode } = useChainSwitch();

  const handleToggle = useCallback(() => {
    toggleTestnetMode();
    if (onPress) {
      onPress();
    }
  }, [toggleTestnetMode, onPress]);

  return (
    <HStack alignItems="center" justifyContent="space-between" gap={2}>
      <TextHeadline as="span">Developer mode</TextHeadline>
      <Switch checked={isTestnetEnabled} onChange={handleToggle} testID="testnet-toggle-switch" />
    </HStack>
  );
}
